import { Linear, Power2, gsap } from "gsap/all";
import { proposalHeroColorTypes, proposalHeroTypes, triangleHeroDropShadow } from "./ProposalHeroConfig";

export const playInitialTweens = (containerType, currentCard, id) => {
  if (id !== currentCard) {
    gsap.to(`.ProposalHeroCircleSquareContainer-${id} .MovingGradient`, { opacity: 0, duration: 0 })
    gsap.to(`.ProposalHeroTriangleContainer-${id} `, { filter: "drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))", duration: 0 })
  }
  if (containerType === proposalHeroTypes.circle.label) {
    gsap.to(`.ProposalHeroCircleSquareContainer .MovingGradient`, { rotation: "+=360", duration: 4, ease: Linear.easeNone, transformOrigin: "50% 50%", repeat: -1 })

  }
  if (containerType === proposalHeroTypes.rectangle.label) {
    gsap.timeline({})
      .to(`.ProposalHeroCircleSquareContainer .MovingGradient`, { x: "1vh", y: "-1vh", duration: 1 }, 0)
      .to(`.ProposalHeroCircleSquareContainer .MovingGradient`, { x: "1vh", y: "1vh", duration: 1 }, 1)
      .to(`.ProposalHeroCircleSquareContainer .MovingGradient`, { x: "-1vh", y: "1vh", duration: 1 }, 2)
      .to(`.ProposalHeroCircleSquareContainer .MovingGradient`, { x: "-1vh", y: "-1vh", duration: 1 }, 3)
      .repeat(-1)
      .play();
  }

}
export function proposalHeroTimeline(id) {
  const proposalHeroTimeline = gsap.timeline({});
  const selectedContainer = `.ProposalHeroCircleSquareContainer-${id}`;
  proposalHeroTimeline
    .fromTo(`${selectedContainer} .ProposalHeroCircleSquare`, { scale: 0.9 }, { scale: 1 }, 0)
    .fromTo(`${selectedContainer} .MovingGradient`, { opacity: 0 }, { opacity: 1, duration: 0 }, 0)
    .fromTo(`${selectedContainer} .ProposalHeroCircleSquareOverlay`, { opacity: 1 }, { opacity: 0, duration: 0 }, 0)
    .fromTo(`${selectedContainer} .ProposalHeroCircleSquareGradientOverlay`, { scale: 1.1 }, { scale: 1, duration: 0.5 }, 0)
    .fromTo(`${selectedContainer} img`, { scale: 1 }, { scale: 1.2 }, 0)
    .fromTo(`${selectedContainer} .ProposalHeroCircleSquareContent`, { fontWeight: "400", scale: "1" }, { fontWeight: "600", scale: "1.2", duration: 0.5 }, 0)

  return proposalHeroTimeline;
}

export function reverseProposalHeroTimeline(id) {
  const proposalHeroTimeline = gsap.timeline({});
  const selectedContainer = `.ProposalHeroCircleSquareContainer-${id}`;
  proposalHeroTimeline
    .fromTo(`${selectedContainer} .ProposalHeroCircleSquare`, { scale: 1 }, { scale: 0.9 }, 0)
    .fromTo(`${selectedContainer} .MovingGradient`, { opacity: 1 }, { opacity: 0, duration: 0 }, 0)
    .fromTo(`${selectedContainer} .ProposalHeroCircleSquareOverlay`, { opacity: 0 }, { opacity: 1, duration: 0 }, 0)
    .fromTo(`${selectedContainer} .ProposalHeroCircleSquareGradientOverlay`, { scale: 1 }, { scale: 1.1, duration: 0.5 }, 0)
    .fromTo(`${selectedContainer} img`, { scale: 1.2 }, { scale: 1 }, 0)
    .fromTo(`${selectedContainer} .ProposalHeroCircleSquareContent`, { fontWeight: "600", scale: "1.2" }, { fontWeight: "400", scale: "1", duration: 0.5 }, 0)

  return proposalHeroTimeline;
}


export function proposalHeroTriangleTimeline(id, colorScheme) {
  const proposalHeroTimeline = gsap.timeline({});
  const selectedContainer = `.ProposalHeroTriangleContainer-${id}`;
  proposalHeroTimeline
    .fromTo(`.ProposalHeroTriangleContainer-${id}.${colorScheme ?? proposalHeroColorTypes.orange} `, { filter: "drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))", scale: 1 }, { scale: 1.05, filter: triangleHeroDropShadow[colorScheme ?? proposalHeroColorTypes.orange], duration: 0.5 })
    .fromTo(`${selectedContainer} .ProposalHeroTriangleOverlay`, { opacity: 1 }, { opacity: 0, duration: 1 }, 0)
    .fromTo(`${selectedContainer} img`, { scale: 1 }, { scale: 1.2 }, 0) //
    .fromTo(`${selectedContainer} .ProposalHeroTriangleOutline`, { opacity: 0 }, { opacity: 1 }, 0) //
    .fromTo(`${selectedContainer} .ProposalHeroTriangleContent`, { fontWeight: "400", scale: "1" }, { fontWeight: "600", scale: "1.2", duration: 0.5 }, 0)


  return proposalHeroTimeline;
}
export function reverseProposalHeroTriangleTimeline(id) {
  const proposalHeroTimeline = gsap.timeline({});
  const selectedContainer = `.ProposalHeroTriangleContainer-${id}`;
  proposalHeroTimeline
    .to(`.ProposalHeroTriangleContainer-${id}`, { filter: "drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))",scale:1, duration: 0.5 })
    .fromTo(`${selectedContainer} .ProposalHeroTriangleOverlay`, { opacity: 0 }, { opacity: 1, duration: 1 }, 0)
    .fromTo(`${selectedContainer} img`, { scale: 1.2 }, { scale: 1 }, 0) //
    .fromTo(`${selectedContainer} .ProposalHeroTriangleOutline`, { opacity: 1 }, { opacity: 0 }, 0)

    .fromTo(`${selectedContainer} .ProposalHeroTriangleContent`, { fontWeight: "600", scale: "1.2" }, { fontWeight: "400", scale: "1", duration: 0.5 }, 0)

  return proposalHeroTimeline;
}





export const proposalHoverTimeline = (id) => {
  const selectedContainer = `.ProposalHeroCircleSquareContainer-${id}`;
  const proposalHoverTimeline = gsap.timeline({});
  proposalHoverTimeline.fromTo(`${selectedContainer} .ProposalHeroCircleSquareContent`, { opacity: 1 }, { opacity: 0, duration: 0.25 }, 0)
  return proposalHoverTimeline;
}
export const proposalHoverTriangleTimeline = (id) => {
  const selectedContainer = `.ProposalHeroTriangleContainer-${id}`;
  const proposalHoverTimeline = gsap.timeline({});
  proposalHoverTimeline.fromTo(`${selectedContainer} .ProposalHeroTriangleContent`, { opacity: 1 }, { opacity: 0, duration: 0.25 }, 0)
  return proposalHoverTimeline;
}


